import React from 'react';
import { X, AlertTriangle, Loader2 } from 'lucide-react';

export default function ConfirmDialog({
    title = 'Confirmar acción',
    message,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    tone = 'default', // 'default' | 'danger'
    submitting = false,
    onConfirm,
    onCancel,
}) {
    const isDanger = tone === 'danger';
    const accent = isDanger ? '#DC2626' : '#111827';

    return (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-6" onClick={onCancel}>
            <div onClick={(e) => e.stopPropagation()}
                className="w-full max-w-md max-h-[calc(100vh-2rem)] overflow-y-auto" data-testid="confirm-dialog"
                style={{ background: 'var(--card-bg, #fff)', border: '1px solid var(--border, #E5E7EB)' }}>
                <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: 'var(--border, #E5E7EB)' }}>
                    <div className="flex items-center gap-3">
                        {isDanger && (
                            <div className="w-10 h-10 flex items-center justify-center" style={{ background: 'rgba(220,38,38,0.12)', color: '#DC2626' }}>
                                <AlertTriangle className="w-5 h-5" />
                            </div>
                        )}
                        <h2 className="font-display text-lg font-black">{title}</h2>
                    </div>
                    <button type="button" onClick={onCancel} className="p-2 hover:bg-black/5 dark:hover:bg-white/10"><X className="w-5 h-5" /></button>
                </div>
                <div className="p-6 text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">{message}</div>
                <div className="px-6 py-4 border-t flex gap-2 justify-end" style={{ borderColor: 'var(--border, #E5E7EB)' }}>
                    <button type="button" onClick={onCancel}
                        className="px-5 py-2 border hover:bg-black/5 dark:hover:bg-white/10" style={{ borderColor: 'var(--border, #E5E7EB)' }}>
                        {cancelLabel}
                    </button>
                    <button type="button" onClick={onConfirm} disabled={submitting}
                        data-testid="confirm-dialog-confirm"
                        className="text-white px-6 py-2 font-bold inline-flex items-center gap-2 disabled:opacity-50"
                        style={{ background: accent }}>
                        {submitting && <Loader2 className="w-4 h-4 animate-spin" />}
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
